interface SwerveSmallProps {
  width: number;
  height: number;
  x?: number;
  y?: number;
  color?: string;
}

const SwerveSmall = (props: SwerveSmallProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" id="Layer_1" data-name="Layer 1" viewBox="0 0 921.17999 921.25" {...props}>
    <defs id="defs1">
      <style id="style1">
        {'.cls-1{stroke-miterlimit:10}.cls-1,.cls-2{fill:none;stroke:#010101}.cls-3{fill:#010101}.cls-2{stroke-linecap:round;stroke-linejoin:round}'}
      </style>
    </defs>
    <g
      id="g163"
      style={{
        display: 'inline',
        fill: '#fff',
        fillOpacity: 1,
        stroke: 'none',
      }}
      transform="translate(-259.77 -259.87)"
    >
      <path
        id="path7"
        d="M1180.95 326.01c0-36.46-29.66-66.12-66.12-66.12h-3.65c-46.281.4-90.607-.02-136.58-.02-2.48 0-4.75 1.42-5.89 3.61l-.04.04v.03l-.07.09-.02.02v.03h-.02v.02c-.41.88-.63 1.85-.63 2.81l.02 413.16-.01.14a5.345 5.345 0 0 1-4.94 4.94h-.21v.01c-161.604.807-323.228-1.128-484.83.01l-.07-.01h-.14a5.363 5.363 0 0 1-4.95-4.94V266.52c0-.97-.22-1.93-.63-2.81v-.02h-.01v-.03l-.03-.02-.06-.09v-.03l-.05-.04c-1.14-2.19-3.42-3.61-5.9-3.61-158.398 0 75.319.03-140.23.03-36.46 0-66.12 29.66-66.12 66.12V608c0 3.61 2.94 6.61 6.55 6.67l61.77 1.08c.3 0 .59.08.85.19l.45.26.13.09c.57.47.93 1.19.93 1.95v204.54c0 .77-.36 1.48-.93 1.95l-.13.09-.45.26c-.27.1-.55.18-.85.19l-61.77 1.08c-3.61.06-6.55 3.06-6.55 6.67l.01 281.96c0 36.46 29.66 66.12 66.12 66.12 247.89 0 14.174.02 140.23.02 2.48 0 4.76-1.42 5.9-3.62l.03-.03v-.03l.08-.11.01-.03v-.03c.4-.88.63-1.84.63-2.81v-59.787c165.086.192 330.077.439 495.177-.347l-.067 60.124c-.001.96.22 1.93.63 2.81v.03h.01v.03h.01l.08.11v.03l.04.03c1.14 2.2 3.42 3.62 5.9 3.62h140.23c36.46 0 66.12-29.66 66.12-66.12V833.01c0-3.61-2.94-6.6-6.55-6.67l-61.77-1.08c-.3 0-.58-.08-.85-.19l-.47-.27-.11-.08c-.58-.47-.94-1.19-.94-1.96V618.22c0-.77.36-1.49.94-1.96l.11-.08.47-.27c.27-.1.55-.18.85-.19l61.77-1.08c3.61-.06 6.55-3.06 6.55-6.67z"
        style={{
          fill: props.color,
          fillOpacity: 1,
          stroke: 'none',
          strokeWidth: 2.3,
          strokeLinejoin: 'round',
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
      />
    </g>
  </svg>
);
export default SwerveSmall;
